var _defs, _path, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5.2 4.681 56.4 56.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: "40%",
    cy: "35%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f878c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#3a3f43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121416"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 32 L12 17 L25 10 L34 13 L45 8 L56 17 L61 31 L55 47 L42 56 L26 55 L11 47Z",
    fill: "url(#j)",
    stroke: "#0e0f10",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8d959a",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17 L25 10 L28 22 L16 26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 13 L45 8 L48 20 L37 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 30 L40 28 L42 38 L30 40Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 56 L55 47 L50 40 L40 46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 47 L26 55 L24 46 L14 42Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#a7aeb3",
    strokeWidth: 0.9,
    fill: "none",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 26 L28 22 L37 23 L48 20 L56 17 M28 22 L28 30 M37 23 L40 28 M16 26 L18 38 L30 40 L42 38 L50 40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResource);
export default __webpack_public_path__ + "static/media/resource.2f6d4c2a1886be9b6c1f82a0859137d3.svg";
export { ForwardRef as ReactComponent };